type Events = {
  wallet_connected: { method: string; value: number };
  refreshBalance: { value: number; userAddress: string };
  'Create Vault: Step 1 choose collection': {
    method: 'User Collection' | 'Custom Address';
  };
  'Create Vault: Existing Vault Decision': {
    action:
      | 'Cancel'
      | 'View Existing Vault'
      | 'Deposit Existing Vault'
      | 'Ignored';
  };
  'Create Vault: Step 2 vault details': {};
  'Create Vault: Step 3 configure pool': {
    liquidity_type: 'Pair' | 'ETH-only' | 'NFT-Only';
    pool_fee: string; // FeeTier
  };
  'Create Vault: Step 4 choose nfts': {};
  'Create Vault: Step 5 configure pool & submit': {};
  'Create Vault: Success': {};
  bug_bounty_clicked: {};
};

const trackEvent = <S extends keyof Events>(name: S, params?: Events[S]) => {
  if (typeof window === 'undefined') {
    return;
  }

  window?.gtag?.('event', name, params || {});
};

export default trackEvent;
